import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Lottery } from '../../../core/lotteries';

// 最後の4桁を切り出し
const maskPhoneNumber = phoneNumber =>
  phoneNumber.length > 0 &&
  phoneNumber.substring(phoneNumber.length - 4, phoneNumber.length);

class LotteryItem extends Component {
  static propTypes = {
    lottery: PropTypes.instanceOf(Lottery).isRequired,
  };

  constructor(props, context) {
    super(props, context);

    this.state = { editing: false };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.lottery !== this.props.lottery ||
      nextState.editing !== this.state.editing
    );
  }

  render() {
    const { lottery } = this.props;
    const status = lottery.status !== 'won';

    return (
      <div className={'lottery-item'} tabIndex="0">
        <div className="cell">
          <button
            aria-hidden={status}
            aria-label="Mark task as completed"
            className={classNames('btn lottery-item__button', { hide: status })}
            onClick={this.toggleStatus}
            ref={c => (this.toggleStatusButton = c)}
            type="button"
          >
            <svg
              className={classNames('icon', { 'icon--active': status })}
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
            </svg>
          </button>
        </div>

        <div className="cell">
          <div className="lottery-item__title">
            {maskPhoneNumber(lottery.phone_number)}
          </div>
        </div>
      </div>
    );
  }
}

export default LotteryItem;



// WEBPACK FOOTER //
// ./src/views/components/lottery-item/index.js